import { getPublicClient, upsertPublicClient } from '../api/companyRecords';

export function normalizeDocuments(value) {
  return Array.isArray(value) ? value : [];
}

export async function listClientDocuments({ companyId, clientId }) {
  const client = await getPublicClient({ companyId, id: clientId });
  return normalizeDocuments(client?.documents);
}

export async function saveClientDocuments({ companyId, clientId, documents }) {
  const next = normalizeDocuments(documents);
  await upsertPublicClient({
    companyId,
    id: clientId,
    record: {
      documents: next,
      updatedAt: new Date().toISOString(),
    },
  });
  return next;
}

export async function addClientDocument({ companyId, clientId, document }) {
  const current = await listClientDocuments({ companyId, clientId });
  return saveClientDocuments({
    companyId,
    clientId,
    documents: [...current, document],
  });
}

export async function removeClientDocument({ companyId, clientId, documentId }) {
  const current = await listClientDocuments({ companyId, clientId });
  return saveClientDocuments({
    companyId,
    clientId,
    documents: current.filter((doc) => doc.id !== documentId),
  });
}
